import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showConfirmationModal } from "../../features/confirmationModal/ConfirmationModalSlice";
import { getLocalizedTime } from "../../utils/timeZone";
import DeleteAdminIcon from "../icons/DeleteAdminIcon";
import EditAdminIcon from "../icons/EditAdminIcon";
import styles from "./oneEmployee.module.css";

const OneEmployee = ({ name, role, addedTime, modifiedTime, adminId }) => {
  const { timeZone } = useSelector((state) => state.timeZone);
  const localizedAddedTime = getLocalizedTime(addedTime, timeZone);
  const localizedModifiedTime = getLocalizedTime(modifiedTime, timeZone);
  const roleLabel = role?.role || "بدون مسمى";
  const roleId = role?._id || role;
  const adminInitials =
    name
      ?.split(" ")
      ?.filter(Boolean)
      ?.slice(0, 2)
      ?.map((word) => word[0])
      ?.join("") || "م";

  const dispatch = useDispatch();

  const { rolePermissions } = useSelector((state) => state.user);

  const handleDeleteAdmin = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من حذف الموظف ؟",
        data: adminId,
        actionType: "deleteAdmin",
      })
    );
  };

  const navigate = useNavigate();

  const handleNavigtionToEditEmployee = () => {
    navigate("/dashboard/emlpoyees/edit-employee", {
      state: {
        name,
        role: roleId,
        adminId,
      },
    });
  };

  return (
    <article className={styles.container}>
      <div className={styles.identityRow}>
        <div className={styles.identityContent}>
          <div className={styles.nameRow}>
            <span className={styles.roleBadge}>{roleLabel}</span>
            <h3 className={styles.name}>{name}</h3>
          </div>
        </div>
        <div className={styles.avatar}>{adminInitials}</div>
      </div>
      <div className={styles.metadataGrid}>
        <div className={styles.metaCard}>
          <span className={styles.metaLabel}>آخر تعديل</span>
          <p className={styles.metaValue}>
            {localizedModifiedTime.toLocaleString()}
          </p>
        </div>
        <div className={styles.metaCard}>
          <span className={styles.metaLabel}>تمت الإضافة</span>
          <p className={styles.metaValue}>
            {localizedAddedTime.toLocaleString()}
          </p>
        </div>
      </div>
      {rolePermissions.includes("update-admins") && (
        <div className={styles.actionsWrapper}>
          <button
            type="button"
            className={`${styles.actionButton} ${styles.editButton}`}
            onClick={handleNavigtionToEditEmployee}
          >
            <EditAdminIcon className={styles.actionIcon} />
            <span>التعديل على الموظف</span>
          </button>
          <button
            type="button"
            className={`${styles.actionButton} ${styles.deleteButton}`}
            onClick={handleDeleteAdmin}
          >
            <DeleteAdminIcon className={styles.actionIcon} />
            <span>حذف الموظف</span>
          </button>
        </div>
      )}
    </article>
  );
};

export default OneEmployee;
